/** Polling interval (ms) for touchpoint header detection */
export const TOUCHPOINT_POLL_INTERVAL_MS = 150;

/** Maximum polling attempts for touchpoint detection */
export const TOUCHPOINT_MAX_ATTEMPTS = 10;
